import { useState, useEffect } from 'react';

function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
        width,
        height
    };
}

export default function useWindowDimensions() {
    const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());

    useEffect(() => {
        function handleResize() {
            setWindowDimensions(getWindowDimensions());
        }

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return windowDimensions;
}
export const guidGenerator =() => {
    let S4 = function() {
        return (((1+Math.random())*0x10000)|0).toString(16).substring(1);
    };
    return (S4()+S4()+"-"+S4()+"-"+S4()+"-"+S4()+"-"+S4()+S4()+S4());
}
export const getCurrentLanguage = (i18n) => {
    // Supported languages
    const supportedLanguages = ['en', 'de'];
    
    let key;
    if(i18n && i18n.language) {
        let language = i18n.language
        if (language && language.includes("-")) {
            key = language.split("-")[0].toLowerCase()
        } else {
            key = language.toLowerCase()
        }
        
        // Validate that the language is supported
        if(key !== undefined && key !== null && supportedLanguages.includes(key)) {
            return key;
        }
        else {
            key = "de";
        }
    }
    else {
        key = "de";
    }
    return key;
}